import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: '/index',
        component: () => import('@/views/Index')
    },
    {
        path: '/login',
        component: () => import('@/views/Login')
    },
    {
        path: '/changepass',
        component: () => import('@/views/ChangePassword')
    },
    {
        path: '/yzsso',
        component: () => import('@/views/YzSSO')
    }
];

const router = new VueRouter({
    routes,
});

router.beforeEach(async (to, from, next) => {
    let path = to.path;

    if (path === "/") {
        if (sessionStorage.getItem("auth-token")) {
            next("/index");
        } else {
            next({path: '/login'});
        }
    } else if (path === "/login") {
        next();
    } else if (path === "/yzsso") {
        next();
    } else {
        if (sessionStorage.getItem("auth-token")) {
            next();
        } else {
            next({path: '/login', query: {redirect: to.fullPath}});
        }
    }
});

export default router;
